import { MdKeyboardDoubleArrowRight } from 'react-icons/md';
import { Link } from 'react-scroll';
import { HeroImage } from '../assets/images';

const Home = () => {
    return (
        <section 
            id="/" 
            className="min-h-screen flex items-center justify-center pt-24 pb-12 md:py-0 overflow-hidden"
        >
            {/* Expanded width to 90% and tight padding to reduce edge margins */}
            <div className="max-w-[90%] mx-auto px-2 sm:px-4 lg:px-4 w-full">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-6 items-center">
                    
                    {/* Text Content Block */}
                    <div className="lg:col-span-7 space-y-5 text-center lg:text-left flex flex-col items-center lg:items-start">
                        
                        <h1 className="uppercase font-bold text-red text-4xl sm:text-5xl xl:text-6xl leading-snug">
                            Legacies Systems{' '}
                            <span className="text-blue block lg:inline">
                                & Software Solutions for All
                            </span>{' '}
                            Business Sectors.
                        </h1>

                        <p className="text-slate-700 leading-7 py-1 text-center lg:text-start font-medium text-lg max-w-2xl">
                            Embark on a transformative journey with our comprehensive system consultancy and implementation services. 
                            From envisioning the design to seamless deployment, we cater to your business needs. 
                            Join us to create tailored solutions for lasting success. Your success story begins with us!
                        </p>
    <Link to="/about-us" smooth duration={500} className="group flex justify-center cursor-pointer w-full md:w-[40%] px-2 bg-red hover:bg-transparent hover:text-red hover:border-blue-500 border-2 shadow-md border-red text-white font-bold py-3 rounded-full transition-all duration-300 mt-4">
                       <p className='px-2'>Discover More</p> 
                        <MdKeyboardDoubleArrowRight size={25} className='-rotate-90 duration-100 ease-in group-hover:rotate-0' />
                    </Link>
                    </div>

                    {/* Image Block */}
                    <div className="lg:col-span-5 w-full flex justify-center lg:justify-end">
                        <img 
                            src={HeroImage} 
                            alt="heroSection" 
                            className="max-w-full md:max-w-[700px] h-auto object-contain overflow-hidden" 
                        />
                    </div>

                </div>
            </div>
        </section>
    );
};

export default Home;
